import { render, staticRenderFns } from "./AddLeadForm.vue?vue&type=template&id=fb052d28&"
import script from "./AddLeadForm.vue?vue&type=script&lang=js&"
export * from "./AddLeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports